import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { regularSubmit } from "../../api/index";

@withRouter
class RegularConfigureModel extends Component{
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      error: false
    };
  }
  componentDidMount() {
    let _submitHandler = this._submitHandler;
    $("#subscription-form").validate({
      rules: {
        email: {required: true, email: true}
      },
      messages: {
        email: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address'
        }
      },
      submitHandler: function(){
        _submitHandler();
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent().next().next());
      }
    });
  }
  _submitHandler = () => {
    let email = $("#subscriber").val();
    let tenantName = this.props.name;
    regularSubmit({email, tenantName})
      .then(res=>{
        let id = res.data;
        if (res.status === "success") {
          this.props.history.push(`/admin/regional-subscription/${id}`);
        }
      })
      .catch(err=>{
        console.log(err);
      });
  };
  render() {
    const companyName = this.props.companyName.toUpperCase();
    let { error } = this.state;
    let {headlineColor} = this.props;
    return (
      <div id="content" className="container">
        <div className="row" style={{marginTop: 14}}>
          <div className="well col-md-6 col-md-offset-3" style={{padding: 20}}>
            <h1 className="login-header-big tex-color-dangreen text-center"
                style={{color: headlineColor}}>
              {`${companyName} Alerts Subscription Management`}
              <br/>
              Administration Page
            </h1>
            <br/>
            <div className="text-center">
              <form id="subscription-form"
                    className="form-inline">
                <div className="form-group email-group" style={{minWidth: 205}}>
                  <label className="sr-only">Email</label>
                  <input
                    autoFocus="autofocus"
                    type="email"
                    className="form-control"
                    style={{width: '100%'}}
                    id="subscriber"
                    name="email"
                    placeholder="Please enter an email address" />
                </div>
                <button
                  type="submit"
                  id="submitBtn"
                  style={{marginLeft: 5}}
                  className="btn btn-success">
                  Submit
                </button>
                <br/>
              </form>
            </div>
            <br/>
            <br/>
            {
              error &&
              <div className="alert alert-danger alert-dismissible fade in" role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                Error
              </div>
            }
            <div className="text-center">
              <button
                className="btn btn-primary btn-addSubscriber"
                style={{padding: '6px 55px'}}
                data-toggle="modal"
                data-target="#addrow_modal">
                Add a new subscriber
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RegularConfigureModel;


// WEBPACK FOOTER //
// ./src/container/regularConfigure/regularConfigureModel.js